export default __webpack_public_path__ + "images/IP.27b6cba.png";